/**
 * @description: 系统设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-system">
        <!-- 清空数据设置 -->
        <div class="store-cdt-set" v-show="show1">
            <div class="cdt-set">
                <h1 class="title">清空数据设置</h1>
                <div class="cdt-notice">
                    <!-- <p>注：</p>
                    <p>1，截止时间不能填写当前时间。例如截止时间设置为2018-07-25，那么25号之前的数据将被清空，25号当天数据不会被清空。</p>
                    <p>2，设置成功后被清空数据将不能恢复。</p>
                    <p>3，截止时间只能选择营业日。</p> -->
                    <span class="red-tip">注：1，只能选择按营业日清空数据，且不支持清空当前营业日数据</span>
                </div>
                <div class="row cdt-time">
                    <label class="col-md-1 ctr-label-left">截止时间：</label>
                    <div class="col-md-4">
                        <div class="time-wrapper" ref="cdtTime">
                            <input type="text" class="form-control laydate-icon" v-model="cdt_endtime" placeholder="请选择清空数据的截止时间">
                        </div>
                    </div>
                </div>
                <!-- <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">操作人：</label>
                    <div class="col-md-4">
                        <p class="cdt-admin">{{username}}</p>
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">操作密码：</label>
                    <div class="col-md-4">
                        <input class="form-control" type="password" placeholder="请输入操作人登录密码" v-model="cdt_psw">
                    </div>
                </div> -->
                <div class="cdt-clear-list clearfix">
                    <!-- <label class="col-md-1 ctr-label-left">清空数据：</label> -->
                    <p>请选择要清空的数据（数据包含对应列表下明细数据表）</p>
                    <div class="main">
                        <h3>
                            <input type="checkbox" v-model='cdt_clear_all' @click='cdtClearAll'>
                            全选
                        </h3>
                        <div v-for="items in cdt_clear_list" :key="items.id">
                            <h3>
                                <input type="checkbox" v-model='cdt_clear_item' :value="items.id">
                                {{items.name}}
                            </h3>
                            <ul class="clearfix">
                                <li v-for="(item, index) in items.detail" :key="item.id">{{`${index + 1}、${item.name}`}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row cdt-btn">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="cdtSub()">确定</button>
                </div>
                <div class="cdt-log">
                    <h2>操作日志</h2>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="cdtLogList"></table>
                    </div>
                </div>
            </div>
            <!-- 清空数据确认弹窗 -->
            <div class="clear-pop ele-hide"  ref="clear_pop">
                <div class="red-tip">确认清空数据？确认后数据将不可修复！</div>
                <el-form label-width="80px">
                    <el-form-item label="操作人">
                        <el-input disabled v-model="username"></el-input>
                    </el-form-item>
                    <el-form-item label="操作密码">
                        <el-input v-model="cdt_psw" 
                            placeholder="请输入操作密码" 
                            type="password"
                            autocomplete="off" 
                            readonly
                            onfocus="this.removeAttribute('readonly')" 
                            onblur="this.setAttribute('readonly', true)">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>


        <!-- 版权歌曲 -->
        <div class="store-cpr-set" v-show="show2">
            <div class="cpr-list" v-show="showCprList">
                <h1 class="title">版权歌曲</h1>
                <p class="p-hint">注：版权歌曲设置后重启三次才能生效；状态禁用表示不可点歌</p>
                <div class="row row-magin-bottom">
                    <label class="ct-label">门店:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="cpr_shop" data-placeholder="请选择门店"></select>
                    </div>
                    <div class="col-md-1 ct-col cpr-tit-sel">
                        <select class="form-control" ref="cpr_query_sel">
                            <option value="1">歌曲名称</option>
                            <option value="2">歌星姓名</option>
                        </select>
                    </div>
                    <div class="col-md-2 cpr-con-val">
                        <input type="text" class="form-control" v-model="cpr_query_val" :placeholder="cpr_query_phd">
                    </div>
                    <div class="pull-right">
                        <button type="button" class="btn btn-flat btn-small btn-orange" @click="clkCprQuery">查询</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="cprList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
            <div class="cpr-det" v-show="showCprDet">
                <div class="page-tit">{{cpr_det_tit}}</div>
                <div class="row row-margin">
                    <div class="col-md-1 ct-col cpr-tit-sel">
                        <select class="form-control" ref="cprdet_query_sel">
                            <option value="1">歌曲名称</option>
                            <option value="2">歌星姓名</option>
                        </select>
                    </div>
                    <div class="col-md-2 cpr-con-val">
                        <input type="text" class="form-control" v-model="cprdet_query_val" :placeholder="cprdet_query_phd">
                    </div>
                    <div class="pull-right">
                        <button type="button" class="btn btn-flat btn-small btn-orange" @click="initCprDetTable">查询</button>
                        <a class="btn btn-flat btn-small btn-orange sub-margin" :href="cpr_det_url" target="_blank">导出</a>
                    </div>
                </div>
                <table class="table table-bordered table-hover" data-pagination="true" ref="cprDetList"></table>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backListCpr">返回</button>
                </div>
            </div>
        </div>


        <!-- 歌曲删除 -->
        <div class="store-gpb-set" v-show="show3">
            <div class="gpb-list" v-show="!showGpbEdit">
                <h1 class="title">歌曲删除</h1>
                <p>注：删除歌曲设置后，包厢机顶盒需重启3次才能生效；取消删除后需要重启4次才能生效</p>
                <el-form :inline="true" :model="gpb_form">
                    <el-form-item label="歌星">
                        <el-input placeholder="请输入歌星名" v-model="gpb_form.szPlayer"></el-input>
                    </el-form-item>
                    <el-form-item label="歌曲">
                        <el-input placeholder="请输入歌曲名" v-model="gpb_form.szSong_name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="gpbAdd">添加删除歌曲</el-button>
                        <el-button type="primary" @click="getGpbTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="gpb_table">
                    <el-table-column type="index" label="行号"></el-table-column>
                    <el-table-column prop="szPlayer" label="歌星"></el-table-column>
                    <el-table-column prop="szSong_name" label="歌曲"></el-table-column>
                    <el-table-column prop="songs_version" label="歌曲版本"></el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="gpb_page"
                    :total="gpb_total"
                    @current-change="getGpbTable">
                </el-pagination>
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
            </div>
            <!-- 添加歌曲 -->
            <div class="gpb-add" v-show="showGpbEdit">
                <el-row :gutter="30">
                    <el-col :span="12">
                        <h2>添加删除歌曲</h2>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-select v-model="gpb_songs_type">
                                    <el-option label="歌曲名称" value="name"></el-option>
                                    <el-option label="歌曲分类" value="szClass"></el-option>
                                    <el-option label="歌手" value="szPlayer"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="10">
                                <el-input placeholder="请输入" v-model="gpb_songs_name"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <el-button class="pull-right" type="primary" @click="getGpbSongsTable(1)">查询</el-button>
                            </el-col>
                        </el-row>
                        <el-table
                            v-loading="loading"
                            element-loading-text="努力加载中，请稍后..."
                            element-loading-background="rgba(0, 0, 0, 0.6)"
                            :data="gpb_songs_table">
                            <el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
                            <el-table-column prop="szClass" label="歌曲分类"></el-table-column>
                            <el-table-column prop="szPlayer" label="歌手"></el-table-column>
                            <el-table-column prop="songs_version" label="版本"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="gpbSongsAdd(scope.row)">添加</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :pager-count="5"
                            :page-size="GLOBAL.PAGESIZE"
                            :current-page.sync="gpb_songs_page"
                            :total="gpb_songs_total"
                            @current-change="getGpbSongsTable">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12">
                        <h2>已添加删除歌曲列表</h2>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-select v-model="add_gpb_songs_type">
                                    <el-option label="歌曲名称" value="name"></el-option>
                                    <el-option label="歌曲分类" value="szClass"></el-option>
                                    <el-option label="歌手" value="szPlayer"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="10">
                                <el-input placeholder="请输入" v-model="add_gpb_songs_name"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <el-button class="pull-right" type="primary" @click="onAlreadySearch">查询</el-button>
                            </el-col>
                        </el-row>
                        <el-table
                            v-loading="loading"
                            element-loading-text="努力加载中，请稍后..."
                            element-loading-background="rgba(0, 0, 0, 0.6)"
                            :data="gpb_add_table">
                            <el-table-column prop="szSong_name" label="歌曲名称"></el-table-column>
                            <el-table-column prop="szClass" label="歌曲分类"></el-table-column>
                            <el-table-column prop="szPlayer" label="歌手"></el-table-column>
                            <el-table-column prop="songs_version" label="版本"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="gpbSongsDel(scope.row, scope.$index)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :pager-count="5"
                            :page-size="page_size"
                            :current-page.sync="gpb_add_page"
                            :total="gpb_add_total"
                            @current-change="getGpbAddTable">
                        </el-pagination>
                    </el-col>
                </el-row>
                <el-row>
                    <el-button @click="showGpbEdit = false">返回</el-button>
                    <el-button type="primary" @click="gdpEdit">确定</el-button>
                </el-row>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                show1: false,
                show2: false,
                show3: false,

                // 清空数据设置
                cdt_endtime: '',
                cdt_psw: '',
                cdt_clear_all: false,
                cdt_clear_item: [],
                cdt_clear_list: [],

                // 版权歌曲
                showCprList: true,
                showCprDet: false,
                cpr_query_field: "1",
				cpr_query_phd: "请输入歌曲名称",
				cpr_query_val: "",
                cprdet_query_field: "1",
				cprdet_query_phd: "请输入歌曲名称",
				cprdet_query_val: "",
                cpr_det_id: '',
                cpr_det_tit: '',
                cpr_det_url: '',

                // 歌曲屏蔽
                gpb_form: {
                    szPlayer: '',
                    szSong_name: ''
				},
				gpb_page: 1,
				gpb_total: 0,
                page_size: 10,
                gpb_table: [],
                showGpbEdit: false,
                gpb_songs_type: '',
                gpb_songs_name: '',
                gpb_songs_page: 1,
                gpb_songs_total: 0,
                gpb_songs_table: [],
                add_gpb_songs_type: '',
                add_gpb_songs_name: '',
                gpb_add_page: 1,
                gpb_add_total: 0,
                gpb_add_table: [],
                gpb_add_table_all: [],
                gpb_add_arr: [],
                gpb_del_ids: [],
                gpb_add_table_original_all: [], // 屏蔽歌曲已添加列表原始数据
            }
        },
		computed: {
			username() {
				return this.$store.state.username
			},
		},
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                const _this = this
                this[`show${num}`] = true

                if(num == '1') {
                    this.cdtClearList()
                    this.innitDate()
                    this.initCdtLogTable()
                } else if(num == '2') {
                    _this.getShopData();
                    // 下拉选项
                    $(_this.$refs.cpr_query_sel).select2({
                        language: "zh-CN",
                        minimumResultsForSearch: -1,
                        width: '100px'
                    }).change(function() {
                        _this.cpr_query_field = $(this).val();
                        _this.cpr_query_val = '';
                        if(_this.cpr_query_field == '1') {
                            _this.cpr_query_phd = '请输入歌曲名称';
                        } else if(_this.cpr_query_field == '2') {
                            _this.cpr_query_phd = '请输入歌星姓名';
                        }
                    });
                    $(_this.$refs.cprdet_query_sel).select2({
                        language: "zh-CN",
                        minimumResultsForSearch: -1,
                        width: '100px'
                    }).change(function() {
                        _this.cprdet_query_field = $(this).val();
                        _this.cprdet_query_val = '';
                        if(_this.cprdet_query_field == '1') {
                            _this.cprdet_query_phd = '请输入歌曲名称';
                        } else if(_this.cprdet_query_field == '2') {
                            _this.cprdet_query_phd = '请输入歌星姓名';
                        }
                    });
                } else if(num == '3') {
                    _this.getGpbTable(1)
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 清空数据设置
             */
            // 获取清空数据
            cdtClearList() {
                const _this = this

				Vue.axios.post('Setting/getCleanDataType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.cdt_clear_list = res.data.response.result
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg('出错啦')
				})
            },
            // 全选
            cdtClearAll: function() {
                const _this = this
                if(!_this.cdt_clear_all) { // 实现全选
                    _this.cdt_clear_item = []
                    _this.cdt_clear_list.forEach(function(item) {
                        _this.cdt_clear_item.push(item.id)
                    })
                } else { // 实现反选
                    _this.cdt_clear_item = []
                }
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.cdtTime).daterangepicker({
                    parentEl: '.cdt-time',
                    singleDatePicker: true, // 设置成单日历
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray'
                }, function(start, end, label) {
                    _this.cdt_endtime = start.format('YYYY-MM-DD');
                });
            },
            // 初始化操作日志
            initCdtLogTable: function() {
                let _this = this;
                $(_this.$refs.cdtLogList).bootstrapTable('destroy');
                $(_this.$refs.cdtLogList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 5,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getCdtLog(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "create_time",
                        title: "时间",
                        width: "8%"
                    }, {
                        field: "data_type_name",
                        title: "清空内容",
                        width: "8%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "8%"
                    }, {
                        field: "end_time",
                        title: "截止时间",
                        width: "8%"
                    }],
                });
            },
            // 获取操作日志数据
            getCdtLog: function(params) {
                let _this = this,
                    pageNumber = 1;

                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getCleanDataModifyLogList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 提交
            cdtSub: function() {
                let _this = this;
                _this.cdt_psw = '';
                
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['清空数据提示', true],
                    area: ['450px', 'auto'], // 宽高
                    content: $(_this.$refs.clear_pop),
                }, function() {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "end_time": _this.cdt_endtime, // 截止时间
                                "pwd": _this.cdt_psw, // 密码
                                "data_type": _this.cdt_clear_item
                            }
                        },
                        "comment": ""
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/modifyCleanData",
                        crossDomain: true,
                        async: false,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.closeAll();
                                layer.msg(data.response.error_msg);
                                _this.initCdtLogTable();
                                _this.cdt_endtime = '';
                                _this.cdt_psw = '';
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },


            /*
             * 版权歌曲
             */
            // 获取门店数据
            getShopData: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            arr.shift();

                            $(_this.$refs.cpr_shop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.cpr_shop).val(arr[0].id).trigger('change');
                            _this.innitCprTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 初始化版权歌曲列表
            innitCprTable: function() {
                let _this = this;
                $(_this.$refs.cprList).bootstrapTable('destroy');
                $(_this.$refs.cprList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getCprList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%",
                        formatter: function(value, row, index) {
                            return $(_this.$refs.cpr_shop).find("option:selected").text();
                        }
                    }, {
                        field: "banned_name",
                        title: "版权歌曲标题",
                        width: "25%"
                    }, {
                        field: "status",
                        title: "状态",
                        width: "25%",
                        formatter: function(value, row, index) {
                            if(row.status == '1') {
                                return '启用';
                            } else if(row.status == '-1') {
                                return '禁用';
                            }
                        }
                    }, {
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .status': function(e, value, row) {
                                let statusText = (row.status == 1) ? '禁用' : '启用',
                                    status = (row.status == 1) ? -1 : 1;
                                layer.confirm("确定"+ statusText +"【"+ row.banned_name +"】？", {
                                    btn: ['确定', '取消'],
                                }, function() {
                                    _this.cgCprStatus(row.id, status);
                                });
                            },
                            'click .detail': function(e, value, row) {
                                _this.cpr_det_id = row.banned_name_id;
                                _this.cpr_det_tit = row.banned_name;
                                _this.cpr_det_url = row.excel_url;
                                _this.initCprDetTable();
                                _this.showCprList = false;
                                _this.showCprDet = true;
                            }
                        },
                        formatter: function(value, row, index) {
                            let statusText = (row.status == 1) ? '禁用' : '启用';

                            return '<span class="text-blue status">'+ statusText +'</span>&nbsp;&nbsp;<span class="text-blue detail">歌曲列表</span>'
                        }
                    }]
                });
            },
            // 版权歌曲列表
            getCprList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": $(_this.$refs.cpr_shop).val(),
                            "search_type": _this.cpr_query_field,
                            "search_key": _this.cpr_query_val
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "bannedSongs/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 查询
            clkCprQuery: function() {
                this.innitCprTable();
            },
            // 启用/禁用
            cgCprStatus: function(id, status) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "status": status
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "bannedSongs/upStatus",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('操作成功');
                            $(_this.$refs.cprList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化歌曲列表
            initCprDetTable: function() {
                let _this = this;
                $(_this.$refs.cprDetList).bootstrapTable('destroy');
                $(_this.$refs.cprDetList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getCprDet(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "szSong_name",
                        title: "歌曲名称",
                        width: "25%"
                    }, {
                        field: "szPlayer",
                        title: "歌星姓名",
                        width: "25%"
                    }, {
                        field: "company",
                        title: "版权管理方",
                        width: "25%"
                    }, {
                        field: "szSong_code",
                        title: "著作权编号",
                        width: "25%"
                    }]
                });
            },
            // 歌曲列表
            getCprDet: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "banned_name_id": _this.cpr_det_id,
                            "search_type": _this.cprdet_query_field,
                            "search_key": _this.cprdet_query_val
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "bannedSongs/getBannedSongsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回列表页
            backListCpr() {
                this.showCprList = true;
                this.showCprDet = false;
            },


            /*
             * 歌曲屏蔽
             */
			getGpbTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BannedSongs/getMerchantBannedSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "szPlayer": _this.gpb_form.szPlayer,
                            "szSong_name": _this.gpb_form.szSong_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gpb_total = Number(res.data.response.result.total);
						}
						_this.gpb_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 点击新增
			gpbAdd() {
				const _this = this;

				_this.gpb_songs_type = 'name'
				_this.gpb_songs_name = ''
                _this.add_gpb_songs_type = 'name'
                _this.add_gpb_songs_name = ''
                _this.gpb_songs_page = 1
                _this.gpb_add_page = 1
                _this.getGpbSongsTable(_this.gpb_songs_page)
                new Promise(resolve => {
					_this.getGpbSongsList(resolve)
				}).then(res => {
                    _this.getGpbAddTable(_this.gpb_add_page)
                })
                // _this.gpb_add_table_all = [..._this.gpb_table]
                _this.gpb_add_arr = []
                _this.gpb_del_ids = []
                _this.showGpbEdit = true
            },
            getGpbSongsTable: function(page) {
				const _this = this;

                _this.loading = true;
                let name = '',
                    szClass = '',
                    szPlayer = '';
                if(_this.gpb_songs_type == 'name') {
                    name = _this.gpb_songs_name;
                } else if(_this.gpb_songs_type == 'szClass') {
                    szClass = _this.gpb_songs_name;
                } else if(_this.gpb_songs_type == 'szPlayer') {
                    szPlayer = _this.gpb_songs_name;
                }
				Vue.axios.post('PublicData/api_getSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "name": name,
                            "szClass": szClass,
                            "szPlayer": szPlayer
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gpb_songs_total = Number(res.data.response.data.total);
						}
						_this.gpb_songs_table = res.data.response.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 获取原始已添加屏蔽歌曲列表
            getGpbSongsList: function(resolve) {
				const _this = this;
                let szSong_name = '',
                    szClass = '',
                    szPlayer = '';
                if(_this.add_gpb_songs_type == 'name') {
                    szSong_name = _this.add_gpb_songs_name;
                } else if(_this.add_gpb_songs_type == 'szClass') {
                    szClass = _this.add_gpb_songs_name;
                } else if(_this.add_gpb_songs_type == 'szPlayer') {
                    szPlayer = _this.add_gpb_songs_name;
                }

				Vue.axios.post('BannedSongs/getMerchantBannedSongsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": 0,
							"page_size": 0,
                            "szSong_name": szSong_name,
                            "szClass": szClass,
                            "szPlayer": szPlayer
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                        _this.gpb_add_table_all = res.data.response.result.rows;
                        _this.gpb_add_table_original_all = JSON.parse(JSON.stringify(res.data.response.result.rows));
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            getGpbAddTable(page) {
                this.gpb_add_total = this.gpb_add_table_all.length
                this.gpb_add_table = []
                const len = this.gpb_add_table_all.length > (page * this.page_size) ? (page * this.page_size) : this.gpb_add_table_all.length
                for(let i = (page - 1) * this.page_size; i < len; i++) {
                    this.gpb_add_table.push(this.gpb_add_table_all[i])
                }
            },

            // 已添加歌曲搜索
            onAlreadySearch() {
                // new Promise(resolve => {
                    // this.getGpbSongsList(resolve)
                    this.searchAlreadyAddList()
                // }).then(res => {
                    this.gpb_add_page = 1
                    this.getGpbAddTable(this.gpb_add_page)
                // })
            },

            // 已添加歌曲列表搜索操作
            searchAlreadyAddList() {
                let _this = this;
                let szSong_name = '',
                    szClass = '',
                    szPlayer = '';
                let res_list = []; // 搜索结果
                let arr = this.gpb_add_arr.concat(this.gpb_add_table_original_all)
                if(_this.add_gpb_songs_type == 'name') {
                    szSong_name = _this.add_gpb_songs_name;
                    if (szSong_name == '') {
                        res_list = arr
                    }else {
                        arr.forEach(item => {
                            if (item.szSong_name.includes(szSong_name)) {
                                res_list.push(item)
                            }
                        })
                    }
                } else if(_this.add_gpb_songs_type == 'szClass') {
                    szClass = _this.add_gpb_songs_name;
                    if (szClass == '') {
                        res_list = arr
                    }else {
                        arr.forEach(item => {
                            if (item.szClass.includes(szClass)) {
                                res_list.push(item)
                            }
                        })
                    }
                } else if(_this.add_gpb_songs_type == 'szPlayer') {
                    szPlayer = _this.add_gpb_songs_name;
                    if (szPlayer == '') {
                        res_list = arr
                    }else {
                        arr.forEach(item => {
                            if (item.szPlayer.includes(szPlayer)) {
                                res_list.push(item)
                            }
                        })
                    }
                }
                this.gpb_add_table_all = res_list
            },

            // 添加屏蔽歌曲
            gpbSongsAdd(row) {
                let arr = this.gpb_add_arr.concat(this.gpb_add_table_original_all)
                for(let i = 0; i < arr.length; i++) {
                    if(row.szSong_code == arr[i].szSong_code) {
                        layer.msg('歌曲已存在')
                        return;
                    }
                }
                this.gpb_add_arr.unshift({
                    "szSong_code": row.szSong_code,
                    "szSong_name": row.szSong_name,
                    "szPlayer": row.szPlayer,
                    "szSong_tile": row.szSong_tile,
                    "songs_version": row.songs_version,
                    "szClass": row.szClass
                })
                this.gpb_add_table_all.unshift({
                    "szSong_code": row.szSong_code,
                    "szSong_name": row.szSong_name,
                    "szPlayer": row.szPlayer,
                    "szSong_tile": row.szSong_tile,
                    "songs_version": row.songs_version,
                    "szClass": row.szClass
                })
                this.add_gpb_songs_name = ''
                // this.gpb_add_page = 1
                // this.getGpbAddTable(this.gpb_add_page)
                this.onAlreadySearch()
                layer.msg('添加成功')
            },
            // 删除屏蔽歌曲
            gpbSongsDel(row, index) {
                if(row.id) {
                    this.gpb_del_ids.push(row.id)
                } else {
                    for(let i = 0; i < this.gpb_add_arr.length; i++) {
                        if(row.szSong_code == this.gpb_add_arr[i].szSong_code) {
                            this.gpb_add_arr.splice(i, 1)
                            break
                        }
                    }
                }
                for(let j = 0; j < this.gpb_add_table_all.length; j++) {
                    if(row.szSong_code == this.gpb_add_table_all[j].szSong_code) {
                        this.gpb_add_table_all.splice(j, 1)
                        break
                    }
                }
                for(let k = 0; k < this.gpb_add_table_original_all.length; k++) {
                    if(row.szSong_code == this.gpb_add_table_original_all[k].szSong_code) {
                        this.gpb_add_table_original_all.splice(k, 1)
                        break
                    }
                }
                this.getGpbAddTable(this.gpb_add_page)
            },
            // 保存
            gdpEdit() {
                const _this = this;
                if (_this.gpb_add_arr == [] && _this.gpb_del_ids == []) {
                    layer.msg('保存成功')
                    _this.getGpbTable(_this.gpb_page)
                    _this.showGpbEdit = false
                    return
                }

                Vue.axios.post('BannedSongs/addMerchantBannedSongs', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "add": _this.gpb_add_arr,
                            "del": _this.gpb_del_ids
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('保存成功')
                        _this.getGpbTable(_this.gpb_page)
                        _this.showGpbEdit = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    // 清空数据设置
    .cdt-set {
        .red-tip {
            color: red;
        }
        .cdt-notice {
            margin: 20px 0 30px;
            color: #9d9d9d;
            font-size: 14px;
            p {
                margin: 0;
            }
        }
        .cdt-time {
            position: relative;
        }
        .cdt-admin {
            line-height: 32px;
            text-align: center;
            background: #DDD;
        }
        .cdt-clear-list {
            p {
                clear: both;
                padding: 0 0 15px 41px;
                color: #9d9d9d;
            }
            .main {
                width: 1100px;
                padding: 0;
                margin: 0 0 0 41px;
                border: 1px solid #dcdcdc;
            }
            h3 {
                padding: 0 0 0 15px;
                margin: 0;
                line-height: 40px;
                font-size: 14px;
                background: #f5f5f5;
            }
            ul {
                padding: 15px 0 24px 15px;
            }
            li {
                float: left;
                width: 33%;
                line-height: 40px;
                font-size: 14px;
            }
        }
        .cdt-btn {
            margin: 60px 41px;
        }
        .cdt-log {
            padding: 30px 0 0;
            margin: 0 41px;
            border-top: 1px solid #b8b8b8;
            h2 {
                font-size: 18px;
            }
        }
    }
    .clear-pop {
        .red-tip {
            margin: 10px 0 30px 0;
            text-align: center;
            color: red;
        }
    }

    // 版权歌曲
    .store-cpr-set {
        .cpr-list {
            p {
                padding: 10px 0 0;
                color: #FF0707;
            }
        }
        .cpr-tit-sel {
            width: 100px;
            padding: 0;
        }
        .cpr-con-val {
            padding-left: 0;
            margin-left: -1px;
        }
    }

    // 歌曲屏蔽
    .store-gpb-set {
        p {
            color: #FF0707;
            margin: 20px 0;
        }
        .gpb-add {
            .el-row {
                margin: 0 0 30px;
            }
        }
    }
</style>